import { render, staticRenderFns } from "./InsurancePlans.vue?vue&type=template&id=512954aa"
import script from "./InsurancePlans.vue?vue&type=script&lang=js"
export * from "./InsurancePlans.vue?vue&type=script&lang=js"
import style0 from "./InsurancePlans.vue?vue&type=style&index=0&id=512954aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports